import React from 'react';
import { useTranslation } from 'react-i18next';

import scss from '../ProjectsList.module.scss';

const DeactivateProjectLabel = ({ name, isActive }) => {
  const { t } = useTranslation('projects');

  return (
    <span>
      {isActive ? t('doYouReallyWantToDeactivate') : t('doYouReallyWantToActivate')}:{' '}
      <span className={scss.stressedName}>{name}</span>?
    </span>
  );
};

export default DeactivateProjectLabel;
